{
  "statusLabels": {
    "active": "Active",
    "suspended": "Suspended",
    "closed": "Closed"
  },
  "tierLabels": {
    "titanium": "Titanium",
    "platinum": "Platinum",
    "diamond": "Diamond",
    "enterprise": "Enterprise",
    "e2": "E2",
    "e3": "E3"
  },
  "list": {
    "header": {
      "title": "Merchants",
      "description": "View, filter, and bulk-act on merchant accounts. Invite-only — no Create button. Suspended merchants stay clickable for read-only sections."
    },
    "toggle": {
      "showClosed": "Show closed merchants"
    },
    "legend": {
      "aria": "Row color legend",
      "label": "Row legend:",
      "suspended": "Suspended",
      "new": "New (< 7 days)"
    },
    "columns": {
      "name": "Name",
      "email": "Email",
      "status": "Status",
      "tier": "Tier",
      "wallet": "Wallet",
      "creditTotal": "Credit total",
      "creditUsed": "Credit used",
      "creditExpiry": "Credit expiry",
      "orders": "Orders",
      "gmv": "GMV",
      "lastLogin": "Last login",
      "stores": "Stores",
      "autoPay": "Auto Pay",
      "autoRecharge": "Auto Recharge",
      "transferBlock": "TG Block",
      "cardPayment": "Card payment",
      "created": "Created",
      "amCs": "AM & CS"
    },
    "filters": {
      "search": {
        "label": "Search",
        "placeholder": "Name, email, business…"
      },
      "status": {
        "label": "Status"
      },
      "tier": {
        "label": "Tier"
      },
      "transferBlock": {
        "label": "Transfer block",
        "blocked": "Blocked",
        "notBlocked": "Not blocked"
      },
      "cardPayment": {
        "label": "Card payment",
        "enabled": "Enabled",
        "disabled": "Disabled"
      },
      "dateRange": "Date range"
    },
    "bulk": {
      "suspend": "Suspend",
      "activate": "Activate",
      "setTier": "Set tier",
      "setCredit": "Set credit",
      "export": "Export CSV"
    },
    "actions": {
      "openAria": "Open merchant {{name}}",
      "openTitle": "Open merchant detail"
    },
    "amCs": {
      "am": "AM",
      "cs": "CS",
      "assign": "Assign",
      "reassignTitle": "Reassign AM & CS"
    },
    "boolean": {
      "on": "On",
      "off": "Off"
    },
    "transferBlocked": {
      "label": "TG Block",
      "title": "Blocked from transfer groups"
    },
    "empty": "No merchants match your filters.",
    "toast": {
      "noSelection": {
        "title": "No merchants selected",
        "description": "Select at least one merchant to run this bulk action."
      },
      "selectFirst": {
        "title": "No merchant selected",
        "suspend": "Select at least one merchant to run bulk suspend.",
        "activate": "Select at least one merchant to run bulk activate.",
        "setTier": "Select at least one merchant to change tier.",
        "setCredit": "Select at least one merchant to set credit."
      },
      "approvalRequired": {
        "title": "Dual approval required",
        "description_one": "Batch parked. Request id {{requestId}}; {{count}} merchant over threshold {{threshold}}.",
        "description_other": "Batch parked. Request id {{requestId}}; {{count}} merchants over threshold {{threshold}}."
      },
      "exportQueued": {
        "title": "Export queued",
        "description_one": "Export job {{jobId}} queued for {{count}} merchant ({{format}}).",
        "description_other": "Export job {{jobId}} queued for {{count}} merchants ({{format}})."
      },
      "applied": {
        "title": "Bulk action applied",
        "description_one": "{{count}} merchant updated.",
        "description_other": "{{count}} merchants updated."
      },
      "failed": {
        "title": "Bulk action failed",
        "networkError": "Network error — check connection"
      }
    },
    "bulkModals": {
      "cancel": "Cancel",
      "pending": "Processing…",
      "suspend": {
        "heading_one": "Bulk suspend {{count}} merchant",
        "heading_other": "Bulk suspend {{count}} merchants",
        "body_one": "Suspend {{count}} selected merchant. Blocks login + new orders; can reactivate later.",
        "body_other": "Suspend {{count}} selected merchants. Blocks login + new orders; can reactivate later.",
        "reasonLabel": "Reason",
        "noteLabel": "Note — max 2000 characters",
        "noteLabelRequired": "Note * — max 2000 characters",
        "notePlaceholderRequired": "Required when \"Other reason\" is selected (≥10 characters).",
        "notePlaceholderOptional": "Optional.",
        "confirm": "Suspend",
        "reasons": {
          "tosViolation": "Terms of service violation (TOS)",
          "fraudSuspected": "Suspected fraud",
          "chargeback": "Prolonged chargeback / dispute",
          "merchantRequest": "At the merchant's request",
          "complianceReview": "Under compliance review",
          "other": "Other reason (explain in note)"
        }
      },
      "activate": {
        "heading_one": "Bulk activate {{count}} merchant",
        "heading_other": "Bulk activate {{count}} merchants",
        "body_one": "Lift the suspension on {{count}} selected merchant. They can log in and place orders again right after you confirm.",
        "body_other": "Lift the suspension on {{count}} selected merchants. They can log in and place orders again right after you confirm.",
        "noteLabel": "Note — max 2000 characters, optional",
        "confirm": "Activate"
      },
      "setTier": {
        "heading_one": "Change tier for {{count}} merchant",
        "heading_other": "Change tier for {{count}} merchants",
        "body_one": "The new tier applies to all {{count}} selected merchant. Tier affects the credit ladder + withdraw permission.",
        "body_other": "The new tier applies to all {{count}} selected merchants. Tier affects the credit ladder + withdraw permission.",
        "tierLabel": "New tier",
        "confirm": "Apply tier"
      },
      "setCredit": {
        "heading_one": "Set credit total for {{count}} merchant",
        "heading_other": "Set credit total for {{count}} merchants",
        "body_one": "Apply the new credit_total to all {{count}} selected merchant. Enter the amount in USD — the system converts it to cents.",
        "body_other": "Apply the new credit_total to all {{count}} selected merchants. Enter the amount in USD — the system converts it to cents.",
        "amountLabel": "Credit total (USD, ≥0)",
        "invalid": "Enter a non-negative number.",
        "centsHint": "= {{cents}} cents",
        "confirm": "Apply credit"
      }
    }
  },
  "tabsNav": {
    "ariaLabel": "Merchant tabs",
    "all": {
      "label": "All",
      "description": "All merchants except closed."
    },
    "active": {
      "label": "Active",
      "description": "Merchants with an active owner."
    },
    "suspended": {
      "label": "Suspended",
      "description": "Merchants whose owner is suspended. Read-only sections still active."
    },
    "new": {
      "label": "New (<7d)",
      "description": "Merchants created within the last 7 days (row tint)."
    },
    "closed": {
      "label": "Closed",
      "description": "Soft-deleted merchants. Hidden by default — toggle on the list page."
    }
  },
  "detail": {
    "back": "Back to Merchants",
    "missingId": "Missing merchant id in URL.",
    "loadingTab": "Loading tab",
    "sectionsLabel": "Merchant detail sections",
    "error": "Failed to load merchant detail",
    "unknownError": "Unknown error",
    "tabs": {
      "overview": "Overview",
      "wallet": "Wallet",
      "credit": "Credit",
      "orders": "Orders",
      "products": "Products",
      "team-stores": "Team & Stores"
    },
    "charCounter": {
      "needChars_one": "Add {{count}} more character",
      "needChars_other": "Add {{count}} more characters",
      "minChars_one": "At least {{count}} character",
      "minChars_other": "At least {{count}} characters",
      "eligible": "Ready"
    },
    "reactivate": {
      "title": "Re-activate merchant",
      "bodyPrefix": "Lift the suspension on ",
      "bodySuffix": ". The merchant regains full access immediately; the audit trail records the operator and reason.",
      "reasonLabel": "Reason (optional)",
      "cancel": "Cancel",
      "confirm": "Re-activate",
      "pending": "Reactivating…"
    },
    "unblockTransfer": {
      "title": "Unblock Transfer Group",
      "bodyPrefix": "Remove the block flag for ",
      "bodySuffix": ". The merchant returns to the recipient list of Transfer Groups right after you confirm. The audit log records who unblocked and why.",
      "existingReasonLabel": "Original block reason:",
      "reasonLabel": "Unblock reason",
      "reasonRange": "(10..{{max}} characters)",
      "placeholder": "e.g. Compliance review complete, merchant is eligible to operate again.",
      "cancel": "Cancel",
      "confirm": "Unblock",
      "pending": "Unblocking…"
    },
    "forceProduct": {
      "titleDelete": "Force delete product",
      "titleUnpublish": "Force unpublish product",
      "bodyPrefix": "Product ",
      "bodyMiddle": " of merchant ",
      "bodyEnd": ".",
      "noteDelete": "Force delete marks it DELETED_BY_ADMIN — this cannot be undone.",
      "noteUnpublish": "Force unpublish hides the product from the storefront; it can be published again later.",
      "codeLabel": "Reason code",
      "codes": {
        "POLICY_VIOLATION": "Policy violation",
        "COPYRIGHT": "Copyright violation",
        "QUALITY": "Quality issue",
        "OTHER": "Other reason"
      },
      "reasonLabel": "Detailed reason",
      "reasonRange": "(10..{{max}} characters)",
      "reasonPlaceholderDelete": "Describe in detail why this product is being force-deleted…",
      "reasonPlaceholderUnpublish": "Describe in detail why this product is being force-unpublished…",
      "notifyEmail": "Email the merchant",
      "notifyInApp": "In-app notification",
      "confirmNameLabel": "Type the merchant name to confirm deletion:",
      "nameMismatch": "Merchant name does not match.",
      "cancel": "Cancel",
      "pending": "Processing…",
      "confirmDelete": "Force delete",
      "confirmUnpublish": "Force unpublish"
    },
    "pricingProfile": {
      "title": "Pricing profile",
      "helper": "Informational tag only — it never changes the pricing formula. Used for reporting and the 2027 cutover.",
      "profiles": {
        "legacy_v2": "Legacy V2",
        "standard": "Standard V3"
      },
      "editLabel": "Change profile",
      "selectLabel": "Pricing profile",
      "reasonLabel": "Reason (required)",
      "reasonPlaceholder": "Why is this tag changing?",
      "reasonRequired": "A reason is required.",
      "save": "Save profile",
      "saving": "Saving…",
      "cancel": "Cancel",
      "auditNote": "Every change is recorded in the audit trail.",
      "noRecalcNote": "Confirmed orders keep their captured pricing — this tag does not recalculate them.",
      "savedToast": "Pricing profile updated.",
      "errorToast": "Could not update the pricing profile."
    }
  },
  "stickyHeader": {
    "actions": {
      "editProfile": "Edit Profile",
      "reactivate": "Reactivate",
      "suspend": "Suspend",
      "blockTransfer": "Block from Transfer Group",
      "unblockTransfer": "Unblock from Transfer Group",
      "blockTransferTitle": "Quarantine from cost-cycle transfer groups",
      "unblockTransferTitle": "Lift the Transfer Group block (POST /:id/transfer-unblock)",
      "impersonate": "Impersonate"
    }
  },
  "overview": {
    "aria": {
      "panel": "Merchant overview"
    },
    "profile": {
      "heading": "Profile",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "businessName": "Business Name",
      "taxId": "Tax ID",
      "businessAddress": "Business Address"
    },
    "kpis": {
      "totalOrders": "Total orders",
      "totalRevenue": "Total revenue",
      "products": "Products",
      "connectedStores": "Connected stores"
    },
    "wallet": {
      "balance": "Wallet balance",
      "creditTotal": "Credit total",
      "pendingTopups": "Pending topups",
      "withdraw": "Withdraw",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "withdrawHintEnterprise": "Enterprise tier",
      "withdrawHintLocked": "Locked: non-Enterprise tier",
      "withdrawHintEnabled": "Enabled — manage in the Wallet tab",
      "withdrawHintDisabled": "Off by default — enable per merchant in the Wallet tab"
    },
    "notes": {
      "heading": "Internal notes",
      "adminOnly": "(admin-only)"
    },
    "activity": {
      "heading": "Recent activity",
      "subtitle": "Last 10 events from the audit log",
      "errorFallback": "Could not load the activity feed",
      "empty": "No events recorded for this merchant yet.",
      "system": "System",
      "dot": {
        "securityAudit": "Security audit",
        "adminAction": "Admin action",
        "ownerAction": "Merchant owner action"
      },
      "relative": {
        "justNow": "just now",
        "minutesAgo_one": "{{count}} minute ago",
        "minutesAgo_other": "{{count}} minutes ago",
        "hoursAgo_one": "{{count}} hour ago",
        "hoursAgo_other": "{{count}} hours ago",
        "daysAgo_one": "{{count}} day ago",
        "daysAgo_other": "{{count}} days ago"
      }
    }
  },
  "wallet": {
    "aria": {
      "panel": "Wallet & billing"
    },
    "errorFallback": "Failed to load wallet detail",
    "cards": {
      "balance": "Wallet balance",
      "creditRemaining": "Credit remaining",
      "pendingTopups": "Pending topups",
      "expires": "Expires {{date}}",
      "noExpiry": "No expiry set",
      "pendingRequests_one": "{{count}} pending request",
      "pendingRequests_other": "{{count}} pending requests"
    },
    "withdraw": {
      "heading": "Withdraw Permission",
      "enterpriseOnly": "(Enterprise only)",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "dailyLimit": "Daily limit:",
      "toggleLabel": "Allow this merchant to withdraw",
      "offByDefaultHint": "Off by default. The merchant sees the Withdraw button only when enabled.",
      "save": "Save",
      "saving": "Saving…",
      "saved": "Withdraw permission updated",
      "saveError": "Failed to update withdraw permission",
      "loadError": "Could not read the current withdraw permission. Editing is disabled so a failed read is not saved as a change."
    },
    "cardPayment": {
      "heading": "Card Payment",
      "toggleLabel": "Allow this merchant to pay by saved card",
      "offByDefaultHint": "Off by default. When enabled, the merchant can pay orders and invoices directly with a saved card instead of their wallet. Invoice-billed merchants can only pay invoices this way, never individual orders.",
      "save": "Save",
      "saving": "Saving…",
      "saved": "Card payment permission updated",
      "saveError": "Failed to update card payment permission",
      "loadError": "Could not read the current card payment permission. Editing is disabled so a failed read is not saved as a change.",
      "maxPerOrder": "Per-charge limit (USD)",
      "maxPerDay": "Daily limit (USD)",
      "noLimitHint": "Leave a box empty for no limit. A card charge cannot be refunded to the card from here, so a limit caps how much a mistake can cost.",
      "noLimitConfirm": "I mean no limit for the empty ceiling(s)",
      "noLimitRequired": "An empty ceiling means unlimited card spend — tick the box to confirm, or enter an amount."
    },
    "creditPolicy": {
      "heading": "Credit policy",
      "autoPay": "Auto pay",
      "autoRecharge": "Auto recharge",
      "totalCredit": "Total credit",
      "creditUsed": "Credit used",
      "on": "On",
      "off": "Off"
    },
    "billingModes": {
      "PREPAID": {
        "label": "Prepaid (top up first)",
        "hint": "Merchant tops up the balance first; no invoices issued."
      },
      "CREDIT": {
        "label": "Credit (auto recharge)",
        "hint": "Wallet auto-recharges from the saved gateway; recharge failure → suspend."
      },
      "INVOICE": {
        "label": "Invoice (NET terms)",
        "hint": "Issues periodic invoices; NET-N days to pay after issuance."
      }
    },
    "switcher": {
      "heading": "Billing mode",
      "description": "The mode governs how wallet/credit/invoice operate. Switch quickly here — detailed config & invoice history live on the full page.",
      "newMode": "New mode",
      "reasonLabel": "Reason (audit, at least 10 characters)",
      "selectTitleAdmin": "Pick a new mode then enter a reason to confirm",
      "selectTitleReadonly": "Only admins can change the mode (accountants are read-only)",
      "reasonPlaceholder": "e.g. switch to INVOICE NET-7 per the contract agreement.",
      "detailLink": "Open the full Finance & Invoices page →",
      "submitting": "Changing…",
      "submit": "Confirm mode change",
      "submitTitleNotAdmin": "Only admins/superadmins can change the mode",
      "submitTitleNotDirty": "Pick a mode different from the current one first",
      "submitTitleReasonShort_one": "Enter {{count}} more character for the reason",
      "submitTitleReasonShort_other": "Enter {{count}} more characters for the reason",
      "submitTitleReady": "Confirm the billing mode change",
      "successMessage": "Switched to {{mode}}.",
      "networkError": "Network error"
    },
    "permission": {
      "readOnly": "Read-only — you lack the billing permission"
    }
  },
  "orders": {
    "aria": {
      "panel": "Merchant orders"
    },
    "errorFallback": "Failed to load orders",
    "columns": {
      "orderNumber": "Order #",
      "status": "Status",
      "grandTotal": "Grand total",
      "created": "Created"
    },
    "empty": "No orders found for this merchant.",
    "pager": {
      "pageInfo_one": "Page {{page}} · {{count}} row",
      "pageInfo_other": "Page {{page}} · {{count}} rows",
      "prev": "Prev",
      "next": "Next"
    },
    "statusLabels": {
      "draft": "Draft",
      "pending_payment": "Pending Payment",
      "pending_emb_payment": "Pending Emb. Payment",
      "confirmed": "Confirmed",
      "assigned": "Assigned",
      "accepted": "Accepted",
      "in_production": "In Production",
      "quality_check": "Quality Check",
      "ready_to_ship": "Ready to Ship",
      "on_hold": "On Hold",
      "pending_reassignment": "Pending Reassign",
      "shipped": "Shipped",
      "partially_shipped": "Partially Shipped",
      "delivered": "Delivered",
      "returned_partial": "Returned (Partial)",
      "partially_cancelled": "Partially Cancelled",
      "cancelled": "Cancelled",
      "attention_required": "Attention Required",
      "unknown": "Unknown"
    }
  },
  "products": {
    "aria": {
      "panel": "Merchant products"
    },
    "errorFallback": "Failed to load products",
    "columns": {
      "avatar": "Avatar",
      "title": "Title",
      "status": "Status",
      "published": "Published",
      "baseCost": "Base cost",
      "created": "Created",
      "actions": "Actions"
    },
    "empty": "No products found for this merchant.",
    "publishedBadge": "Published",
    "draftBadge": "Draft",
    "actions": {
      "forceUnpublish": "Force Unpublish",
      "forceDelete": "Force Delete",
      "handlerUnavailable": "This action is not available in this context.",
      "unpublishNoTarget": "The product is in Draft state (not published) — nothing to unpublish.",
      "unpublishReady": "Hide the product from the storefront. You can publish it again later.",
      "deleteReady": "Force delete marks DELETED_BY_ADMIN — it cannot be restored.",
      "forceUnpublishAria": "Force Unpublish — {{reason}}",
      "forceDeleteAria": "Force Delete — {{reason}}"
    },
    "pager": {
      "pageInfo_one": "Page {{page}} · {{count}} row",
      "pageInfo_other": "Page {{page}} · {{count}} rows",
      "prev": "Prev",
      "next": "Next"
    },
    "statusLabels": {
      "draft": "Draft",
      "active": "Active",
      "inactive": "Inactive",
      "archived": "Archived",
      "deleted": "Deleted",
      "published": "Published",
      "unpublished": "Unpublished",
      "pending": "Pending"
    }
  },
  "teamStores": {
    "aria": {
      "panel": "Merchant team and stores"
    },
    "errorFallback": "Failed to load team & stores",
    "readonlyBanner": "Note: The Team & Stores section is view-only — Printway admins do not add / edit / remove members (, merchant autonomy). Suspending the whole merchant automatically freezes all team members.",
    "team": {
      "heading": "Team members",
      "empty": "No team members.",
      "columns": {
        "name": "Name",
        "email": "Email",
        "role": "Role",
        "status": "Status",
        "joined": "Joined"
      }
    },
    "stores": {
      "heading": "Connected stores",
      "empty": "No connected stores.",
      "openLink": "Open Store Detail",
      "columns": {
        "store": "Store",
        "platform": "Platform",
        "domain": "Domain",
        "status": "Status",
        "connected": "Connected",
        "actions": "Actions"
      }
    },
    "roleLabels": {
      "owner": "Owner",
      "accountant": "Accountant",
      "operator": "Operator",
      "viewer": "Viewer",
      "member": "Member"
    },
    "teamStatusLabels": {
      "pending": "Pending",
      "active": "Active",
      "suspended": "Suspended",
      "removed": "Removed",
      "inactive": "Inactive"
    },
    "storeStatusLabels": {
      "Active": "Active",
      "Disconnected": "Disconnected",
      "Frozen": "Frozen",
      "Inactive": "Inactive"
    },
    "platformLabels": {
      "shopify": "Shopify",
      "etsy": "Etsy",
      "woocommerce": "WooCommerce",
      "tiktok": "TikTok",
      "amazon": "Amazon",
      "manual": "Manual",
      "unknown": "Unknown"
    }
  },
  "modals": {
    "common": {
      "cancel": "Cancel",
      "charsNeeded_one": "{{count}} more character needed",
      "charsNeeded_other": "{{count}} more characters needed",
      "ready": "Ready",
      "networkError": "Network error — check connection",
      "minCharsPlaceholder": "At least {{min}} characters…",
      "reasonWithMinPlaceholder": "Enter a reason (at least {{min}} characters)…"
    },
    "blockTransfer": {
      "title": "Block merchant from Transfer Group",
      "description": {
        "withName": "Merchant {{name}} will be removed from the recipient list of every Transfer Group. This action does NOT affect login, orders or wallet — it only blocks the merchant from being moved into a cost-transfer group.",
        "withoutName": "The merchant will be removed from the recipient list of every Transfer Group. This does NOT affect login / orders / wallet."
      },
      "reasonLegend": "Block reason",
      "reasons": {
        "fraud_suspected": {
          "label": "Fraud suspected",
          "hint": "Signs of fraud detected — investigate before allowing a transfer."
        },
        "abnormal_pattern": {
          "label": "Abnormal transaction pattern",
          "hint": "Order volume / frequency pattern deviates sharply from the baseline."
        },
        "compliance_review": {
          "label": "Compliance review in progress",
          "hint": "The compliance team is reviewing the file — transfers are paused during the review."
        },
        "merchant_request": {
          "label": "At the merchant's request",
          "hint": "The merchant requested the block — e.g. pausing their business."
        },
        "other": {
          "label": "Other reason",
          "hint": "Describe it in the note field below."
        }
      },
      "noteLabel": "Note",
      "notePlaceholder": {
        "required": "Since you chose \"Other reason\", please describe in detail (at least 10 characters)…",
        "optional": "Additional note (optional). {{hint}}"
      },
      "confirm": "Block from Transfer Group",
      "submitting": "Blocking…"
    },
    "forceDeleteProduct": {
      "title": "Force delete product",
      "description": {
        "withProduct": "This action CANNOT be undone. The product {{product}} will be flagged DELETED_BY_ADMIN and disappear from merchant {{merchant}}'s catalog.",
        "withoutProduct": "This action CANNOT be undone. The product will be flagged DELETED_BY_ADMIN and disappear from merchant {{merchant}}'s catalog."
      },
      "reasonCodeLabel": "Reason code",
      "reasonCodes": {
        "POLICY_VIOLATION": "Policy violation (POLICY_VIOLATION)",
        "COPYRIGHT": "Copyright (COPYRIGHT)",
        "QUALITY": "Quality (QUALITY)",
        "OTHER": "Other (OTHER)"
      },
      "detailLabel": "Detailed reason",
      "notifyEmail": "Send email to the merchant",
      "notifyInApp": "Send an in-app notification to the merchant",
      "confirmNameLabel": "To confirm, type the exact merchant name {{name}}",
      "nameMismatch": "Name does not match.",
      "confirm": "Force delete product",
      "submitting": "Deleting…"
    },
    "freezeWallet": {
      "title": {
        "freeze": "Freeze merchant wallet",
        "unfreeze": "Unfreeze merchant wallet"
      },
      "description": {
        "freezeWithName": "Merchant {{name}}'s wallet will move to Suspended. All new debit transactions will be rejected.",
        "freezeWithoutName": "The merchant wallet will move to Suspended. All new debit transactions will be rejected.",
        "unfreezeWithName": "Merchant {{name}}'s wallet will be reopened (Active). Wallets in chargeback recovery state are not affected.",
        "unfreezeWithoutName": "The merchant wallet will return to Active. Wallets in chargeback recovery state are not affected."
      },
      "currencyScope": "Applies only to the {{currency}} currency wallet.",
      "reasonLabel": "Reason",
      "confirm": {
        "freeze": "Freeze wallet",
        "unfreeze": "Unfreeze wallet"
      },
      "submitting": "Processing…"
    },
    "impersonate": {
      "title": {
        "withLabel": "Login as Merchant — {{name}}",
        "plain": "Login as Merchant"
      },
      "description": "You will log in on behalf of the merchant for support / investigation. Every action is fully audit-logged.",
      "supportDenied": "Support Admin accounts are not allowed to impersonate. Please contact a Super Admin if needed.",
      "warningBanner": {
        "title": "You will be logged in as this merchant. All actions audit-logged.",
        "subtitle": "Every action in this session will be written to the audit log."
      },
      "modePreview": {
        "title": "Mode: read-only + allowlist of 3 actions",
        "ordersView": "orders:view — view orders",
        "merchantsView": "merchants:view — view merchant profile",
        "storesView": "stores:view — view stores",
        "note": "Any other write action will be rejected by the server with code IMPERSONATE_READONLY during the impersonation session."
      },
      "cookieInfo": {
        "title": "The cookie will be set on the subdomain:",
        "expiry": "The impersonation session expires after 30 minutes."
      },
      "reasonLabel": "Reason (audit, ≥ {{min}} characters)",
      "confirm": "Impersonate Merchant",
      "submitting": "Starting…"
    },
    "suspend": {
      "title": "Suspend merchant",
      "description": {
        "withName": "Merchant {{name}} will move to the Suspended state. All wallets will be frozen and in-progress orders held.",
        "withoutName": "The merchant will move to the Suspended state. Wallets frozen, in-progress orders held."
      },
      "dualApprovalBanner": "Bulk > 5 merchants — dual approval is required before applying to the whole selection.",
      "previewSummary": "{{orders}} in-progress orders will be held, {{stores}} stores stop syncing, {{wallets}} wallets locked.",
      "previewError": "Could not load preview data",
      "previewLoading": "Loading preview…",
      "reasonCodeLabel": "Reason code",
      "reasonCodes": {
        "FRAUD": "Fraud (FRAUD)",
        "NON_PAYMENT": "Non-payment (NON_PAYMENT)",
        "POLICY_VIOLATION": "Policy violation (POLICY_VIOLATION)",
        "CHARGEBACK": "Chargeback",
        "KYC_FAILURE": "KYC failure (KYC_FAILURE)",
        "SECURITY": "Security (SECURITY)",
        "VOLUNTARY_REQUEST": "Voluntary request (VOLUNTARY_REQUEST)",
        "OTHER": "Other (OTHER)"
      },
      "reasonLabel": "Suspension reason",
      "notify": "Notify the merchant (email + in-app)",
      "confirm": "Suspend merchant",
      "submitting": "Suspending…"
    },
    "setEditCredit": {
      "title": {
        "edit": "Edit credit limit",
        "new": "Grant credit limit"
      },
      "description": {
        "withName": "Merchant {{name}}. All changes are recorded to the audit log.",
        "withoutName": "All changes are recorded to the audit log."
      },
      "limitLabel": "Limit (USD)",
      "periodLabel": "Period (days)",
      "remindAtLabel": "Remind at usage (USD)",
      "remindAtPlaceholder": "Leave empty for no reminder",
      "limitWarning": "The credit limit can only be increased, not decreased.",
      "notify": "Notify the merchant on grant/edit",
      "autoLock": "Auto-lock when overdue (auto-lock overdue,)",
      "autoReset": "Auto-reset the period (auto-reset)",
      "reasonLabel": "Reason",
      "confirm": {
        "edit": "Save changes",
        "new": "Grant limit"
      },
      "submitting": "Saving…"
    }
  },
  "edit": {
    "missingId": "Missing merchant id in route.",
    "noPermission": "You do not have permission to edit merchants.",
    "loading": "Loading merchant for edit…",
    "loadError": "Failed to load merchant: {{message}}",
    "header": {
      "title": "Edit merchant profile",
      "subtitle": "Editing {{name}} · changes recorded to the merchant audit trail (MERCHANT_PROFILE_UPDATED)."
    },
    "savedToast": "Saved · {{time}}",
    "fields": {
      "businessName": "Business name",
      "phone": "Phone",
      "taxId": "Tax ID",
      "street": "Street",
      "city": "City",
      "region": "Region",
      "postalCode": "Postal code",
      "country": "Country (ISO-3166 alpha-2)",
      "contractLegalEntity": "Contracting legal entity"
    },
    "addressLegend": "Business address (optional — clear all to remove)",
    "reasonLabel": "Reason for change (optional, max 500 chars — captured in audit metadata)",
    "validation": {
      "businessNameMin": "Business name must be at least 2 characters.",
      "phoneFormat": "Phone must be E.164 format (e.g. +14155551234) or empty.",
      "fixHighlighted": "Fix the highlighted fields and try again.",
      "unknownError": "Unknown error"
    },
    "dirtyCount_one": "{{count}} field changed",
    "dirtyCount_other": "{{count}} fields changed",
    "noChanges": "No changes pending",
    "confirmDiscard": "Unsaved changes will be lost. Cancel anyway?",
    "cancel": "Cancel",
    "save": "Save changes",
    "saving": "Saving…",
    "contractEntity": {
      "loading": "Loading…",
      "systemDefault": "System default entity",
      "defaultTag": "{{name}} (default)",
      "unknownEntity": "Unknown entity ({{id}})",
      "hint": "Invoices, receipts and payment requests are issued from this entity. Leave on system default unless the merchant has a dedicated contract."
    }
  }
}
